<template>
    <div>
        
    </div>
</template>
<script>
export default {
    name: 'MeetingDelete'
    
}
</script>
<style>
    
</style>